// environments in the cluster use ENV
const testEnvs = ['dev', 'ci', 'qa']

// environment locally should set NODE_ENV
const testNodeEnvs = ['development', 'test']

const isDev = () => process.env.ENV === 'dev'
const isCi = () => process.env.ENV === 'ci'
const isQa = () => process.env.ENV === 'qa'
const isProd = () => process.env.ENV === 'prod'
const isDisasterRecovery = () =>
  ['qause2', 'produse2'].includes(process.env.ENV)
const isClusterEnv = () => isCi() || isQa() || isProd() || isDisasterRecovery()

const canUseDom = () =>
  !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  )

const isNode = !canUseDom()
const isBrowser = canUseDom()

// NOTE: Some open-source code calls this isCi, which is already in use here and means 'are we executing in the ci
// cluster.' I have specifically not called this `isJenkins` so code doesn't need to care about the details of how we
// actually build code. This is the same check our build scripts use also
//
// For future humans, verifying from the presence of variables here should in theory work though, should you choose to
// make this check more complex to avoid false positives:
// https://jenkins-m1.infra.aucn.io/env-vars.html/
const isExecutingOnBuildServer = () => Boolean(process.env.BUILD_NUMBER)

// This is important to distinguish between different releases on different environments. Downstream developer tooling
// leverages this to, for example, show the first release we saw a regression appear, or to correlate elevated error
// rates with a new version deployment.
const versionIdentifier = () => {
  // This would be equivalent to running `git rev-parse --short HEAD` to get a shortened version of a commit.
  // We do this more for the tooling than anything else. The long form hash of 40 chars would work, but isn't read as easily
  // as a short reference
  const commitRef = (process.env.META_GIT_COMMIT || '').slice(0, 7)

  // NOTE: We _always_ expects ENV to be present in all environments. Other code relies on this also so should be safe
  // to assume as axiomatic.
  return [process.env.ENV, commitRef].filter(Boolean).join('-')
}

module.exports = {
  isDev,
  isCi,
  isQa,
  isProd,
  isDisasterRecovery,
  isClusterEnv,
  testEnvs,
  testNodeEnvs,
  isNode,
  isBrowser,
  canUseDom,
  isExecutingOnBuildServer,
  versionIdentifier,
}
